module.exports = __webpack_public_path__ + "img/Signup-modal-Image.988312e2.png";